import React from "react";
import styled, { css } from "styled-components";
import settings from "@src/settings";
import { up } from "styled-breakpoints";
import { motion } from "framer-motion";
import trimLeading from "@src/utils/trimLeading";
import Nav from "./Nav";
import { WindowSizeInfo } from "@src/utils/useWindowSize";

export const Frame = styled.div<{ windowSize: WindowSizeInfo }>`
	display: flex;
	align-items: center;
	width: ${(props) =>
		props.windowSize?.width ? `${props.windowSize.width}px` : "100%"};
	height: ${(props) =>
		props.windowSize?.height ? `${props.windowSize.height}px` : "100%"};
	& > ${Nav} {
		flex: 1 1 auto;
		height: 100%;
	}
`;

export const ImgCont = styled.div<{ windowSize: WindowSizeInfo }>`
	flex: 0 0 80%;
	overflow: hidden;
	position: relative;
	${(props) => {
		if (props.windowSize && props.windowSize.width && props.windowSize.height) {
			const { width: winW, height: winH } = props.windowSize;
			if (winW >= winH) {
				return css`
					max-width: ${winH * 0.98}px;
					height: ${winH * 0.98}px;
				`;
			} else {
				return css`
					max-width: ${winW * 0.98}px;
					height: ${winW * 0.98}px;
				`;
			}
		}
	}}
`;
export const Item = styled(motion.div)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
`;
export const Img = styled.div`
	display: block;
	border-radius: ${settings.radius.small}px;
	overflow: hidden;
`;

export const Caption = styled.p`
	${trimLeading({ fontSize: 14, lineHeight: 23 })}
	font-family: ${settings.font.jp};
	font-style: normal;
	letter-spacing: 0.11em;
	color: #212121;
	${Img} + & {
		margin-top: 1rem;
	}
`;
